export const BOARD_INVITE_QUERY_PARAM = 'g';
export const LEGACY_BOARD_INVITE_QUERY_PARAM = 'b';
export const SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM = 'board';

export function getBoardInviteSlug(searchParams: URLSearchParams): string | null {
  return (
    searchParams.get(BOARD_INVITE_QUERY_PARAM) ??
    searchParams.get(LEGACY_BOARD_INVITE_QUERY_PARAM) ??
    searchParams.get(SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM)
  );
}

export function setBoardInviteSlug(searchParams: URLSearchParams, inviteSlug: string): void {
  searchParams.set(BOARD_INVITE_QUERY_PARAM, inviteSlug);
  searchParams.delete(LEGACY_BOARD_INVITE_QUERY_PARAM);
  searchParams.delete(SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM);
}

export function canonicalizeBoardInviteSearchParams(
  searchParams: URLSearchParams,
  inviteSlug?: string | null
): boolean {
  const canonicalInviteSlug =
    inviteSlug ??
    searchParams.get(BOARD_INVITE_QUERY_PARAM) ??
    searchParams.get(LEGACY_BOARD_INVITE_QUERY_PARAM) ??
    searchParams.get(SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM);

  let changed = false;

  if (canonicalInviteSlug && searchParams.get(BOARD_INVITE_QUERY_PARAM) !== canonicalInviteSlug) {
    searchParams.set(BOARD_INVITE_QUERY_PARAM, canonicalInviteSlug);
    changed = true;
  }

  if (searchParams.has(LEGACY_BOARD_INVITE_QUERY_PARAM)) {
    searchParams.delete(LEGACY_BOARD_INVITE_QUERY_PARAM);
    changed = true;
  }

  if (searchParams.has(SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM)) {
    searchParams.delete(SUPER_LEGACY_BOARD_INVITE_QUERY_PARAM);
    changed = true;
  }

  return changed;
}

export function buildBoardInviteSearch(inviteSlug: string): string {
  const searchParams = new URLSearchParams();
  setBoardInviteSlug(searchParams, inviteSlug);
  return `?${searchParams.toString()}`;
}
